import { NgModule } from "@angular/core";
import { CoreModule } from "../../core/core.module";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { PipesModule } from "../../pipes/pipes.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedElementsModule } from "../shared/shared-elements.module";
import { ElementsBillingNagDialogComponent } from "./upgrade-nag-dialog/upgrade-nag-dialog.component";
import { ElementsOrganizationsFiltersComponent } from "./organizations-filters/elements-organizations-filters.component";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        PipesModule,
        SharedElementsModule,
        ElementsBillingNagDialogComponent,
        ElementsOrganizationsFiltersComponent,
    ],
    exports: [ElementsBillingNagDialogComponent, ElementsOrganizationsFiltersComponent],
})
export class OrganizationElementsModule {}
